import { render, staticRenderFns } from "./ColorCustoms.vue?vue&type=template&id=e1fe4528"
import script from "./ColorCustoms.vue?vue&type=script&lang=js"
export * from "./ColorCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports